import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function useFlags() {
  const { data } = useQuery({
    queryKey: ["public-flags"],
    queryFn: async () =>
      (await axios.get(`${BACKEND_URL}/api/public/feature-flags`)).data,
    // Keep flags fresh so admin toggles reach live users quickly.
    // staleTime=5s → tab refocus + navigation both trigger immediate refetch.
    staleTime: 5_000,
    refetchOnWindowFocus: true,
    refetchInterval: 60_000,
  });
  const byKey = {};
  (data?.flags || []).forEach((f) => { byKey[f.feature_key] = f; });
  return {
    all: data?.flags || [],
    byKey,
    isVisible(key) {
      const f = byKey[key];
      return f ? !!f.is_visible : true; // default open if not seeded
    },
    isPremium(key) {
      const f = byKey[key];
      return f ? !!f.is_premium : false;
    },
  };
}
